// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"487ff9f7","85":"c8be04fc","997":"487ff9f7"}[chunkId] + ".chunk.css";
};